<ion-header>
    <ion-toolbar style="padding: .75rem 0 .5rem 0;">
        <ion-buttons slot="start">
            <ion-button color="primary">
                <ion-spinner color="primary" name="lines-sharp-small" [class.hidden]="!loading"></ion-spinner>
            </ion-button>
        </ion-buttons>
        <ion-title class="montserrat" style="font-size: 20px; font-weight: 600;">New Message</ion-title>
        <ion-buttons slot="end">
            <ion-button color="primary" (click)="modalC.dismiss()">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content scrollY="false">
    <div class="chat-container">
        <ng-container *ngIf="!selectedProfile; else isSelected">
            <ion-searchbar #searchbar placeholder="Search Username" [(ngModel)]="searchFor"
                (ionInput)="doSearch($event)" [debounce]="400"></ion-searchbar>

            <div class="results" #overflow>
                <ng-container *ngIf="!loading && profiles && profiles.length > 0">
                    <ng-container *ngFor="let p of profiles">
                        <ion-item class="result zoomInSmall delay-child-fast" lines="none" 
                            (click)="selectProfile(p)">
                            <img [src]="p.pfp" alt="" class="pfp" slot="start" (error)="onError($event, p.firstName)">
                            <ion-label>
                                <h3>{{ p.firstName }}&nbsp;{{ p.lastName }}</h3>
                                <p>{{ p.title }} - {{ p.company }}</p>
                                <!-- <small>{{p.uuid}}</small> -->
                            </ion-label>
                        </ion-item>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!loading && profiles && profiles.length == 0">
                    <div class="w-100 text-center text2 mt-3">
                        No results
                    </div>
                </ng-container>
            </div>
        </ng-container>

        <ng-template #isSelected>
            <ion-item class="result bigger" lines="none"  (click)="reselect()">
                <img [src]="selectedProfile.pfp" alt="" class="pfp" slot="start"  (error)="onError($event, selectedProfile.firstName)">
                <ion-label>
                    <h3>{{ selectedProfile.firstName }}&nbsp;{{ selectedProfile.lastName }}</h3>
                    <p>{{ selectedProfile.title }} - {{ selectedProfile.company }}</p>
                </ion-label>
            </ion-item>
        </ng-template>

        <div class="inputs">
            <textarea id="message" appTextareaAutosize rows="1" [minRows]="1" [maxRows]="4"
                placeholder="Write a message..." [(ngModel)]="newMessage" name="message" class="message-input" autofocus
                (keydown.enter)="sendMessage()"></textarea>
            <ion-icon [class.disabled]="!canSend" color="primary" name="arrow-up-circle"
                (click)="sendMessage()"></ion-icon>
        </div>
    </div>

    <!-- <div class="ion-margin-top">
    <ion-label>Click the handle above to advance to the next breakpoint.</ion-label>
    </div>

    <div class="bottom-container">
        
    </div> -->
</ion-content>